module.exports = __webpack_public_path__ + "static/img/selectYearVariable1.aceda545.png";